<template>
  <b-list-group-item class="py-1 px-0">
    <div class="d-flex align-items-center">
      <slot name="before" />

      <base-switch v-model="status" on-text="BDX" off-text="BDX" class="mx-2" />

      <slot />
    </div>
  </b-list-group-item>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'BDXStatusModalItem',
  emits: ['input'],
  props: {
    value: Boolean
  },
  setup(props, { emit }) {
    const status = computed({
      get: () => props.value,
      set: (newStatus) => emit('input', newStatus)
    })

    return {
      status
    }
  }
})
</script>

<style scoped>
.inactive-badge {
  min-width: 75px;
}
</style>
